<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        style="max-width:36px !important"
        icon
        @click.stop=""
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Education Backgrounds"
      text="Create education backgrounds"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="educationLevel"
                v-validate="'required'"
                :items="educationLevels"
                label="Education Level"
                :error-messages="errors.collect('educationLevel')"
                data-vv-name="educationLevel"    
                data-vv-as="education level"     
                item-text="name"
                item-value="id"
                outlined
                :class="{
                  'required':!educationLevel
                }"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="educationMajor"
                v-validate="'required'"
                :items="educationMajors"
                label="Education Major"
                :error-messages="errors.collect('educationMajor')"
                data-vv-name="educationMajor"    
                data-vv-as="education major"     
                item-text="name"
                item-value="id"
                outlined
                :class="{
                  'required':!educationMajor
                }"
              />
            </v-col>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete 
                v-model="country"
                v-validate="'required'"
                :items="countries"
                label="Country"
                :error-messages="errors.collect('country')"
                data-vv-name="country"  
                item-text="name"
                item-value="id"
                outlined
                :class="{
                  'required':!country
                }"
                @change="educationInstitution = null"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="educationInstitute"
                v-validate="'required'"
                :items="filterededucationInstitutes"
                label="Education Institute"
                :error-messages="errors.collect('educationInstitute')"
                data-vv-name="educationInstitute"    
                data-vv-as="education institute"     
                item-text="name"
                item-value="id"
                outlined
                :class="{
                  'required':!educationInstitute
                }"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="result"
                label="Result" 
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="graduationYear"
                v-mask="mask"
                v-validate="'required'"
                label="Graduation Year"
                :error-messages="errors.collect('graduationYear')"
                data-vv-name="graduationYear"    
                data-vv-as="graduation year"
                outlined
                :class="{
                  'required':!graduationYear
                }"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        result: null,
        graduationYear: null,
        mask: '####',
        educationLevel: null,
        educationLevels: [],
        educationMajor: null,
        educationMajors: [],
        country: null,
        countries: [],
        educationInstitute: null,
        educationInstitutes: [],
      }
    },

    computed: {
      filterededucationInstitutes () {
        if (!this.country) return []
        
        return this.educationInstitutes.filter(educationInstitution => {
          return educationInstitution.country_id === this.country
        })
      },
    },

    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
        this.loading = true
     
        Promise.all([
          this.$api.hrisEducationLevels().list(),
          this.$api.hrisEducationMajors().list(),
          this.$api.hrisEducationInstitutes().list(),
          this.$api.hrisCountries().list(),
        ])
          .then(([educationLevels, educationMajors, educationInstitutes, countries]) => {
            this.educationLevels = educationLevels.data
            this.educationMajors = educationMajors.data
            this.educationInstitutes = educationInstitutes.data
            this.countries = countries.data

            this.loading = false
          })
      },
    },
    methods: { 
      prepareFormData () {
        return {
          education_level_id: this.educationLevel,
          education_major_id: this.educationMajor,
          country_id: this.country,
          education_institution_id: this.educationInstitute,
          result: this.result,
          graduation_year: this.graduationYear,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.hrisEducationBackgrounds().create(this.employeeUid, this.prepareFormData())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false       
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
    },
  }
</script>

<style scoped>
.required >>> fieldset {
  border: 2px solid red;
}
</style>
